import React from "react";
import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Button, DialogActions, DialogTitle, TextField } from "@mui/material";
import { LoadCargo } from "../../../../../domain/usecases/load-cargo";
import { OverwriteCargo } from "../../../../../domain/usecases/overwrite-cargo";
import { normalizeCargo } from "../../../../utils/normalize-cargo";

type Props = {
  open: boolean;
  handleClose: () => void;
  oldCargoId: number;
  loadCargo: LoadCargo;
  overwriteCargo: OverwriteCargo;
  onSuccess: () => void;
};

const OverwriteCargoDialog = (props: Props) => {
  const [reference, setReference] = useState("");

  async function onConfirm() {
    if (!reference) {
      return alert("Digite o número da nova carga antes de continuar");
    }
    const newCargo = await props.loadCargo.load(reference);
    if (!newCargo) {
      return alert("Nova carga não encontrada");
    }
    newCargo.cargoItems.map((item) => {
      if (item.batches && item.batches.length > 0) {
        const totalAmount = item.batches?.reduce((acc, batch) => {
          acc += batch.amount;
          return acc;
        }, 0);

        if (totalAmount != item.totalAmount) {
          alert(
            `A quantidade reservada dos lotes do produto ${item.productReference} não coincide com o total da carga`
          );
        }
      }
    });
    const warehouseString = localStorage.getItem("currentWarehouse");
    const warehouse = warehouseString
      ? (JSON.parse(warehouseString) as {
          id: number;
          name: string;
        } | null)
      : undefined;
    const normalizedCargo = normalizeCargo(
      newCargo,
      new Date().toISOString(),
      warehouse!.id
    );

    await props.overwriteCargo.overwrite({
      newCargo: normalizedCargo,
      oldCargoId: props.oldCargoId,
    });
  }
  return (
    <Dialog open={props.open} onClose={props.handleClose}>
      <DialogTitle id="alert-dialog-title">Sobrescrever carga</DialogTitle>
      <DialogContent>
        <TextField
          value={reference}
          onChange={(e) => {
            setReference(e.target.value);
          }}
          sx={{ mt: "10px" }}
          size="small"
          label="Número da nova carga"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose}>Cancelar</Button>
        <Button
          onClick={async () => {
            try {
              await onConfirm();
              props.onSuccess();
              props.handleClose();
            } catch (error) {
              alert(error);
            }
          }}
          autoFocus
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OverwriteCargoDialog;
